export default __webpack_public_path__ + "static/media/admin.77a25d60.svg";